export default __webpack_public_path__ + "static/The Home_image 1@2x-32fd492f070d12fbcd20c018024d7229.jpg";